import { isEmpty } from 'lodash/fp';

import getValuePropositionData from '../../../explained-term/detail/utils/get-value-propositon-data';
import type { ValuePropositionContent } from '../../types';

const getWhyAhmSection = (valuePropositionGroups?: ValuePropositionContent) => {
  if (!valuePropositionGroups || isEmpty(valuePropositionGroups)) {
    return {};
  }
  const whyAhmSectionGroup = valuePropositionGroups[0];
  if (!whyAhmSectionGroup) {
    return {};
  }
  const { item } = whyAhmSectionGroup;
  const whyAhmSectionTitle = item?.name;
  const whyAhmTileData = getValuePropositionData(item?.valuePropositionsReference);
  return { whyAhmSectionTitle, whyAhmTileData };
};

export default getWhyAhmSection;
